import React, { useEffect, useState, lazy } from 'react';
import { Search, ShoppingBag, Filter, ChevronDown, Star, Heart, Package, Flame, Sparkles, Zap, Leaf, Coffee, Utensils, ShoppingCart, Gift, Camera, Tag, ChevronRight, Play, Image as ImageIcon, Lock, Crown, DollarSign, Plus, Pill, Smartphone, Check, X } from 'lucide-react';
export const CreatorMarketplace: React.FC = () => {
  const [activeCategory, setActiveCategory] = useState('all');
  const [marketplaceCategory, setMarketplaceCategory] = useState('all');
  const [searchQuery, setSearchQuery] = useState('');
  const [showFilters, setShowFilters] = useState(false);
  const [priceRange, setPriceRange] = useState([0, 100]);
  const [sortBy, setSortBy] = useState('popular');
  const [hoveredProduct, setHoveredProduct] = useState<string | null>(null);
  const [cartItems, setCartItems] = useState<string[]>([]);
  const [showQuickView, setShowQuickView] = useState<string | null>(null);
  // Listen for marketplace category change events
  useEffect(() => {
    const handleCategoryChange = (event: CustomEvent) => {
      if (event.detail && event.detail.category) {
        setMarketplaceCategory(event.detail.category);
      }
    };
    document.addEventListener('changeMarketplaceCategory', handleCategoryChange as EventListener);
    return () => {
      document.removeEventListener('changeMarketplaceCategory', handleCategoryChange as EventListener);
    };
  }, []);
  // Sample data for marketplace items
  // Angel Skins data
  const angelSkins = [{
    id: 'skin1',
    name: 'Naughty Nurse Lana',
    description: 'Transform Lana into a seductive nurse fantasy',
    subtitle: 'Exclusive role-play experience',
    price: 49.99,
    rating: 4.9,
    reviews: 213,
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/cLp9w3hC4dVahxHuCeYw1i/488653244_669275086051024_406085801635574977_n.jpg',
    category: 'angel_skins',
    tags: ['bestseller', 'fantasy', 'roleplay'],
    inStock: true,
    angelName: 'Lana',
    tokenReward: 25,
    isNew: false,
    isBestseller: true
  }, {
    id: 'skin2',
    name: 'Dominatrix Harper',
    description: 'Harper in full leather dominatrix outfit with accessories',
    subtitle: 'Unleash your submissive desires',
    price: 59.99,
    rating: 4.8,
    reviews: 176,
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/8g53dZ7J3kRR9dJNnGuDbc/h2.png',
    category: 'angel_skins',
    tags: ['premium', 'bdsm', 'leather'],
    inStock: true,
    angelName: 'Harper',
    tokenReward: 35,
    isNew: true,
    isBestseller: false
  }, {
    id: 'skin3',
    name: 'Schoolgirl Bonny',
    description: 'Innocent yet seductive schoolgirl outfit for Bonny',
    subtitle: 'The perfect blend of innocence and seduction',
    price: 39.99,
    rating: 4.7,
    reviews: 142,
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/jq4Dkth7vgkmZJ8GZmzWDP/bonnyblue.png',
    category: 'angel_skins',
    tags: ['popular', 'roleplay', 'innocent'],
    inStock: true,
    angelName: 'Bonny Blue',
    tokenReward: 20,
    isNew: false,
    isBestseller: false
  }, {
    id: 'skin4',
    name: 'Bikini Kim',
    description: 'Kim in a revealing micro bikini on the beach',
    subtitle: 'Hot summer fantasy just for you',
    price: 29.99,
    rating: 4.6,
    reviews: 118,
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/bZ3iVXv5nZEMY6F847weq5/kimholland.png',
    category: 'angel_skins',
    tags: ['summer', 'beach', 'swimwear'],
    inStock: true,
    angelName: 'Kim Holland',
    tokenReward: 15,
    isNew: true,
    isBestseller: false
  }];
  // Premium Videos data
  const premiumVideos = [{
    id: 'vid1',
    name: 'Private Shower Time',
    description: 'Exclusive intimate shower video with Lana (15 mins)',
    subtitle: 'Steamy moments under running water',
    price: 24.99,
    rating: 4.9,
    reviews: 287,
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/cLp9w3hC4dVahxHuCeYw1i/488653244_669275086051024_406085801635574977_n.jpg',
    category: 'premium_videos',
    tags: ['exclusive', '4K', 'shower'],
    inStock: true,
    angelName: 'Lana',
    duration: '15:23',
    tokenReward: 12,
    isNew: false,
    isBestseller: true
  }, {
    id: 'vid2',
    name: 'Bedroom Confession',
    description: 'Harper reveals her deepest fantasies in this intimate video',
    subtitle: 'Whispered desires just for your ears',
    price: 29.99,
    rating: 4.8,
    reviews: 192,
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/8g53dZ7J3kRR9dJNnGuDbc/h2.png',
    category: 'premium_videos',
    tags: ['confession', 'fantasy', 'bedroom'],
    inStock: true,
    angelName: 'Harper',
    duration: '18:47',
    tokenReward: 15,
    isNew: true,
    isBestseller: false
  }, {
    id: 'vid3',
    name: 'Morning Routine',
    description: 'Join Bonny during her intimate morning routine',
    subtitle: 'The first moments of her day, revealed',
    price: 19.99,
    rating: 4.7,
    reviews: 156,
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/jq4Dkth7vgkmZJ8GZmzWDP/bonnyblue.png',
    category: 'premium_videos',
    tags: ['morning', 'routine', 'intimate'],
    inStock: true,
    angelName: 'Bonny Blue',
    duration: '12:38',
    tokenReward: 10,
    isNew: false,
    isBestseller: false
  }, {
    id: 'vid4',
    name: 'Hot Tub Adventure',
    description: 'Kim gets playful in a private hot tub session',
    subtitle: 'Bubbles, steam, and unfiltered pleasure',
    price: 34.99,
    rating: 4.9,
    reviews: 213,
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/bZ3iVXv5nZEMY6F847weq5/kimholland.png',
    category: 'premium_videos',
    tags: ['hot tub', 'wet', 'exclusive'],
    inStock: true,
    angelName: 'Kim Holland',
    duration: '22:15',
    tokenReward: 18,
    isNew: false,
    isBestseller: true
  }];
  // Picture Sets data
  const pictureSets = [{
    id: 'pic1',
    name: 'Lingerie Collection',
    description: '50 high-res photos of Lana in premium lingerie',
    subtitle: 'Lace, silk, and pure seduction',
    price: 19.99,
    rating: 4.8,
    reviews: 176,
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/cLp9w3hC4dVahxHuCeYw1i/488653244_669275086051024_406085801635574977_n.jpg',
    category: 'picture_sets',
    tags: ['lingerie', 'high-res', 'collection'],
    inStock: true,
    angelName: 'Lana',
    photoCount: 50,
    tokenReward: 10,
    isNew: false,
    isBestseller: true
  }, {
    id: 'pic2',
    name: 'Beach Vacation',
    description: '35 exclusive beach photos of Harper in Bali',
    subtitle: 'Sun-kissed skin on exotic shores',
    price: 15.99,
    rating: 4.7,
    reviews: 143,
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/8g53dZ7J3kRR9dJNnGuDbc/h2.png',
    category: 'picture_sets',
    tags: ['beach', 'vacation', 'bikini'],
    inStock: true,
    angelName: 'Harper',
    photoCount: 35,
    tokenReward: 8,
    isNew: true,
    isBestseller: false
  }, {
    id: 'pic3',
    name: 'Bedroom Tease',
    description: '40 intimate bedroom photos of Bonny',
    subtitle: 'Private moments in her personal space',
    price: 17.99,
    rating: 4.9,
    reviews: 198,
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/jq4Dkth7vgkmZJ8GZmzWDP/bonnyblue.png',
    category: 'picture_sets',
    tags: ['bedroom', 'tease', 'intimate'],
    inStock: true,
    angelName: 'Bonny Blue',
    photoCount: 40,
    tokenReward: 9,
    isNew: false,
    isBestseller: true
  }, {
    id: 'pic4',
    name: 'Bathtub Dreams',
    description: '30 sensual bathtub photos of Kim',
    subtitle: 'Bubbles barely covering all the right places',
    price: 14.99,
    rating: 4.8,
    reviews: 165,
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/bZ3iVXv5nZEMY6F847weq5/kimholland.png',
    category: 'picture_sets',
    tags: ['bathtub', 'wet', 'bubbles'],
    inStock: true,
    angelName: 'Kim Holland',
    photoCount: 30,
    tokenReward: 7,
    isNew: true,
    isBestseller: false
  }];
  // Combine all marketplace items
  const supplements = [{
    id: 's1',
    name: 'Passion Enhancer',
    description: 'Natural supplement to boost intimacy and desire',
    subtitle: 'Scientifically formulated for peak performance',
    price: 29.99,
    rating: 4.7,
    reviews: 128,
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/aUC6jLJshiosg2ewioWf27/pasted-image.jpg',
    category: 'supplements',
    tags: ['bestseller', 'natural'],
    inStock: true,
    tokenReward: 15,
    isNew: false,
    isBestseller: true
  }, {
    id: 's2',
    name: 'Stamina Booster',
    description: 'Improve endurance and performance naturally',
    subtitle: 'Last longer, perform stronger',
    price: 34.99,
    rating: 4.5,
    reviews: 96,
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/dSAVufusYPepQmA56LnB8q/pasted-image.png',
    category: 'supplements',
    tags: ['popular', 'vegan'],
    inStock: true,
    tokenReward: 17,
    isNew: false,
    isBestseller: false
  }, {
    id: 's3',
    name: 'Mood Elevation Complex',
    description: 'Enhance your mood and reduce stress',
    subtitle: 'Elevate your experiences to new heights',
    price: 27.99,
    rating: 4.3,
    reviews: 74,
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/4ZhxXzGWbzbPD45oH597H8/pasted-image.png',
    category: 'supplements',
    tags: ['stress-relief', 'natural'],
    inStock: false,
    tokenReward: 14,
    isNew: true,
    isBestseller: false
  }];
  const toys = [{
    id: 't1',
    name: 'Wireless Pleasure',
    description: 'App-controlled intimate toy with multiple vibration patterns',
    subtitle: 'Connect from anywhere in the world',
    price: 89.99,
    rating: 4.8,
    reviews: 215,
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/c8K5W4evZUThoGRhJc8vSs/pasted-image.jpg',
    category: 'toys',
    tags: ['bestseller', 'app-controlled'],
    inStock: true,
    tokenReward: 45,
    isNew: false,
    isBestseller: true
  }, {
    id: 't2',
    name: 'Couples Delight',
    description: 'Designed for shared intimate experiences',
    subtitle: 'Double the pleasure, double the fun',
    price: 79.99,
    rating: 4.6,
    reviews: 187,
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/ujtYcC5wskehBMTntppt9s/pasted-image.png',
    category: 'toys',
    tags: ['couples', 'waterproof'],
    inStock: true,
    tokenReward: 40,
    isNew: true,
    isBestseller: false
  }, {
    id: 't3',
    name: 'Premium Silicone Wand',
    description: 'Ultra-soft silicone with multiple intensity levels',
    subtitle: 'The ultimate in sensual satisfaction',
    price: 64.99,
    rating: 4.5,
    reviews: 156,
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/c8K5W4evZUThoGRhJc8vSs/pasted-image.jpg',
    category: 'toys',
    tags: ['premium', 'rechargeable'],
    inStock: true,
    tokenReward: 32,
    isNew: false,
    isBestseller: false
  }];
  const lingerie = [{
    id: 'l1',
    name: 'Lace Fantasy Set',
    description: 'Delicate lace lingerie set with adjustable straps',
    subtitle: 'Feel as beautiful as you look',
    price: 49.99,
    rating: 4.7,
    reviews: 143,
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/4ZhxXzGWbzbPD45oH597H8/pasted-image.png',
    category: 'lingerie',
    tags: ['bestseller', 'lace'],
    inStock: true,
    tokenReward: 25,
    isNew: false,
    isBestseller: true
  }, {
    id: 'l2',
    name: 'Silk Elegance Robe',
    description: 'Luxurious silk robe for ultimate comfort',
    subtitle: 'Wrap yourself in pure luxury',
    price: 59.99,
    rating: 4.6,
    reviews: 98,
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/ujtYcC5wskehBMTntppt9s/pasted-image.png',
    category: 'lingerie',
    tags: ['premium', 'silk'],
    inStock: true,
    tokenReward: 30,
    isNew: true,
    isBestseller: false
  }, {
    id: 'l3',
    name: 'Seductive Bodysuit',
    description: 'Figure-flattering bodysuit with intricate details',
    subtitle: 'Curves in all the right places',
    price: 44.99,
    rating: 4.5,
    reviews: 112,
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/4ZhxXzGWbzbPD45oH597H8/pasted-image.png',
    category: 'lingerie',
    tags: ['popular', 'stretchy'],
    inStock: false,
    tokenReward: 22,
    isNew: false,
    isBestseller: false
  }];
  // Function to get personalized recommendations
  const getPersonalizedRecommendations = <T extends any,>(products: T[], count: number = 4): {
    items: T[];
    reasons: Record<string, string>;
  } => {
    // Sort by rating and take the top N
    const topProducts = [...products].sort((a, b) => b.rating - a.rating).slice(0, count);
    // Create reasons map
    const reasons: Record<string, string> = {};
    topProducts.forEach(product => {
      if (product.isBestseller) {
        reasons[product.id] = 'Based on your interest in bestsellers';
      } else if (product.isNew) {
        reasons[product.id] = 'New release you might enjoy';
      } else {
        reasons[product.id] = 'Recommended for your preferences';
      }
    });
    return {
      items: topProducts,
      reasons
    };
  };
  // Get personalized recommendations
  const {
    items: personalizedSupplements,
    reasons: supplementReasons
  } = getPersonalizedRecommendations(supplements, 2);
  const {
    items: personalizedToys,
    reasons: toyReasons
  } = getPersonalizedRecommendations(toys, 2);
  // Filter items based on active category and search query
  const getFilteredItems = () => {
    let allItems = [...supplements, ...toys, ...lingerie];
    // Add special marketplace categories if they are active
    if (marketplaceCategory === 'angel_skins' || activeCategory === 'angel_skins') {
      allItems = [...angelSkins];
    } else if (marketplaceCategory === 'premium_videos' || activeCategory === 'premium_videos') {
      allItems = [...premiumVideos];
    } else if (marketplaceCategory === 'picture_sets' || activeCategory === 'picture_sets') {
      allItems = [...pictureSets];
    }
    let filtered = allItems;
    if (activeCategory !== 'all' && marketplaceCategory === 'all') {
      filtered = filtered.filter(item => item.category === activeCategory);
    }
    if (searchQuery) {
      const query = searchQuery.toLowerCase();
      filtered = filtered.filter(item => item.name.toLowerCase().includes(query) || item.description.toLowerCase().includes(query) || item.tags && item.tags.some(tag => tag.toLowerCase().includes(query)));
    }
    // Apply price filter
    filtered = filtered.filter(item => item.price >= priceRange[0] && item.price <= priceRange[1]);
    // Apply sorting
    if (sortBy === 'price-low') {
      filtered.sort((a, b) => a.price - b.price);
    } else if (sortBy === 'price-high') {
      filtered.sort((a, b) => b.price - a.price);
    } else if (sortBy === 'rating') {
      filtered.sort((a, b) => b.rating - a.rating);
    } else if (sortBy === 'newest') {
      // In a real app, you'd sort by date
      filtered.sort((a, b) => (b.isNew ? 1 : 0) - (a.isNew ? 1 : 0));
    } else {
      // Default: popular (by number of reviews)
      filtered.sort((a, b) => b.reviews - a.reviews);
    }
    return filtered;
  };
  const filteredItems = getFilteredItems();
  // Add to cart function
  const handleAddToCart = (itemId: string) => {
    setCartItems(prev => [...prev, itemId]);
    // Show a toast or notification here
  };
  // Handle quick view
  const handleQuickView = (itemId: string) => {
    setShowQuickView(itemId);
  };
  // Render marketplace category header
  const renderMarketplaceCategoryHeader = () => {
    if (marketplaceCategory === 'angel_skins') {
      return <div className="mb-6 bg-gradient-to-r from-purple-50 to-pink-50 dark:from-purple-900/20 dark:to-pink-900/20 rounded-xl p-4 border border-purple-100 dark:border-purple-800/30" data-id="element-5675">
          <div className="flex flex-col md:flex-row items-center gap-4" data-id="element-5676">
            <div className="flex-shrink-0" data-id="element-5677">
              <div className="w-12 h-12 bg-gradient-to-r from-purple-500 to-pink-500 rounded-full flex items-center justify-center" data-id="element-5678">
                <Sparkles size={20} className="text-white" data-id="element-5679" />
              </div>
            </div>
            <div className="flex-grow text-center md:text-left" data-id="element-5680">
              <h3 className="text-lg font-bold mb-1" data-id="element-5681">Angel Skins Shop</h3>
              <p className="text-sm text-gray-600 dark:text-gray-300" data-id="element-5682">
                Transform your favorite angels with exclusive skins and outfits.
                Unlock new experiences!
              </p>
            </div>
            <div className="flex-shrink-0" data-id="element-5683">
              <div className="px-3 py-1.5 bg-pink-100 dark:bg-pink-900/30 text-pink-600 dark:text-pink-400 rounded-full text-sm font-medium" data-id="element-5684">
                <span className="flex items-center gap-1" data-id="element-5685">
                  <Crown size={14} data-id="element-5686" />
                  <span data-id="element-5687">4 New Skins</span>
                </span>
              </div>
            </div>
          </div>
        </div>;
    } else if (marketplaceCategory === 'premium_videos') {
      return <div className="mb-6 bg-gradient-to-r from-red-50 to-pink-50 dark:from-red-900/20 dark:to-pink-900/20 rounded-xl p-4 border border-red-100 dark:border-red-800/30" data-id="element-5688">
          <div className="flex flex-col md:flex-row items-center gap-4" data-id="element-5689">
            <div className="flex-shrink-0" data-id="element-5690">
              <div className="w-12 h-12 bg-gradient-to-r from-red-500 to-pink-500 rounded-full flex items-center justify-center" data-id="element-5691">
                <Play size={20} className="text-white" data-id="element-5692" />
              </div>
            </div>
            <div className="flex-grow text-center md:text-left" data-id="element-5693">
              <h3 className="text-lg font-bold mb-1" data-id="element-5694">Premium Videos</h3>
              <p className="text-sm text-gray-600 dark:text-gray-300" data-id="element-5695">
                Exclusive intimate videos with your favorite angels.
                High-quality content you won't find anywhere else.
              </p>
            </div>
            <div className="flex-shrink-0" data-id="element-5696">
              <div className="px-3 py-1.5 bg-red-100 dark:bg-red-900/30 text-red-600 dark:text-red-400 rounded-full text-sm font-medium" data-id="element-5697">
                <span className="flex items-center gap-1" data-id="element-5698">
                  <Flame size={14} data-id="element-5699" />
                  <span data-id="element-5700">Hot Content</span>
                </span>
              </div>
            </div>
          </div>
        </div>;
    } else if (marketplaceCategory === 'picture_sets') {
      return <div className="mb-6 bg-gradient-to-r from-blue-50 to-indigo-50 dark:from-blue-900/20 dark:to-indigo-900/20 rounded-xl p-4 border border-blue-100 dark:border-blue-800/30" data-id="element-5701">
          <div className="flex flex-col md:flex-row items-center gap-4" data-id="element-5702">
            <div className="flex-shrink-0" data-id="element-5703">
              <div className="w-12 h-12 bg-gradient-to-r from-blue-500 to-indigo-500 rounded-full flex items-center justify-center" data-id="element-5704">
                <Camera size={20} className="text-white" data-id="element-5705" />
              </div>
            </div>
            <div className="flex-grow text-center md:text-left" data-id="element-5706">
              <h3 className="text-lg font-bold mb-1" data-id="element-5707">Picture Sets</h3>
              <p className="text-sm text-gray-600 dark:text-gray-300" data-id="element-5708">
                High-resolution photo collections featuring your favorite angels
                in exclusive settings and poses.
              </p>
            </div>
            <div className="flex-shrink-0" data-id="element-5709">
              <div className="px-3 py-1.5 bg-blue-100 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400 rounded-full text-sm font-medium" data-id="element-5710">
                <span className="flex items-center gap-1" data-id="element-5711">
                  <ImageIcon size={14} data-id="element-5712" />
                  <span data-id="element-5713">HD Quality</span>
                </span>
              </div>
            </div>
          </div>
        </div>;
    }
    return null;
  };
  // Render product card with enhanced styling
  const renderProductCard = (item: any) => {
    const isHovered = hoveredProduct === item.id;
    const isInCart = cartItems.includes(item.id);
    return <div key={item.id} className="bg-white dark:bg-gray-800/90 rounded-xl border border-gray-200 dark:border-gray-700 overflow-hidden shadow-sm hover:shadow-xl hover:shadow-pink-500/10 transition-all duration-300 transform hover:-translate-y-1" onMouseEnter={() => setHoveredProduct(item.id)} onMouseLeave={() => setHoveredProduct(null)} data-id="element-5714">
        {/* Product image with hover effect */}
        <div className="relative aspect-[4/3] overflow-hidden" data-id="element-5715">
          <img src={item.image} alt={item.name} className={`w-full h-full object-cover transition-transform duration-300 ${isHovered ? 'scale-110' : 'scale-100'}`} loading="lazy" data-id="element-5716" />
          {/* Bestseller or New ribbon */}
          {item.isBestseller && <div className="absolute top-2 left-0 bg-gradient-to-r from-amber-500 to-yellow-500 text-white text-xs font-bold px-3 py-1 rounded-r-full shadow-md" data-id="element-5717">
              <span className="flex items-center" data-id="element-5718">
                <Star size={12} className="mr-1" fill="currentColor" data-id="element-5719" />
                BESTSELLER
              </span>
            </div>}
          {item.isNew && !item.isBestseller && <div className="absolute top-2 left-0 bg-gradient-to-r from-blue-500 to-cyan-500 text-white text-xs font-bold px-3 py-1 rounded-r-full shadow-md" data-id="element-5720">
              <span className="flex items-center" data-id="element-5721">
                <Sparkles size={12} className="mr-1" data-id="element-5722" />
                NEW
              </span>
            </div>}
          {/* Quick view button on hover */}
          {isHovered && <div className="absolute inset-0 bg-black/40 flex items-center justify-center opacity-0 hover:opacity-100 transition-opacity duration-300" data-id="element-5723">
              <button onClick={() => handleQuickView(item.id)} className="px-4 py-2 bg-white/90 backdrop-blur-sm text-gray-900 rounded-full text-sm font-medium hover:bg-white transition-colors" data-id="element-5724">
                Quick View
              </button>
            </div>}
          {/* Category badge */}
          <div className="absolute bottom-2 left-2 bg-black/60 backdrop-blur-sm text-white text-xs px-2 py-1 rounded-full" data-id="element-5725">
            {item.category === 'angel_skins' && <span className="flex items-center gap-1" data-id="element-5726">
                <Sparkles size={10} data-id="element-5727" />
                Angel Skin
              </span>}
            {item.category === 'premium_videos' && <span className="flex items-center gap-1" data-id="element-5728">
                <Play size={10} data-id="element-5729" />
                Video
              </span>}
            {item.category === 'picture_sets' && <span className="flex items-center gap-1" data-id="element-5730">
                <Camera size={10} data-id="element-5731" />
                Pictures
              </span>}
            {item.category === 'supplements' && <span className="flex items-center gap-1" data-id="element-5732">
                <Pill size={10} data-id="element-5733" />
                Supplement
              </span>}
            {item.category === 'toys' && <span className="flex items-center gap-1" data-id="element-5734">
                <Smartphone size={10} data-id="element-5735" />
                Toy
              </span>}
            {item.category === 'lingerie' && <span className="flex items-center gap-1" data-id="element-5736">
                <Heart size={10} data-id="element-5737" />
                Lingerie
              </span>}
          </div>
        </div>
        {/* Product content */}
        <div className="p-4" data-id="element-5738">
          {/* Rating */}
          <div className="flex justify-end mb-1" data-id="element-5739">
            <div className="flex items-center gap-1 text-amber-500" data-id="element-5740">
              <Star size={14} fill="currentColor" data-id="element-5741" />
              <span className="text-xs font-medium" data-id="element-5742">
                {item.rating} ({item.reviews})
              </span>
            </div>
          </div>
          {/* Title and subtitle */}
          <h3 className="font-bold text-gray-900 dark:text-white text-lg mb-1" data-id="element-5743">
            {item.name}
          </h3>
          <p className="text-sm italic text-gray-600 dark:text-gray-300 font-serif mb-3" data-id="element-5744">
            {item.subtitle}
          </p>
          {/* Price and token reward */}
          <div className="flex items-center justify-between mb-3" data-id="element-5745">
            <span className="font-bold text-lg text-gray-900 dark:text-white" data-id="element-5746">
              ${item.price.toFixed(2)}
            </span>
            <div className="flex items-center gap-1 bg-amber-100 dark:bg-amber-900/30 px-2 py-1 rounded-full" data-id="element-5747">
              <Heart size={12} className="text-pink-500" fill="currentColor" data-id="element-5748" />
              <span className="text-xs text-amber-800 dark:text-amber-300 font-medium" data-id="element-5749">
                Earn {item.tokenReward} LuvTokens
              </span>
            </div>
          </div>
          {/* Add to cart button */}
          <button onClick={() => handleAddToCart(item.id)} className={`w-full py-2 rounded-full text-sm font-medium transition-all duration-300 flex items-center justify-center gap-1 ${isInCart ? 'bg-green-100 dark:bg-green-900/30 text-green-600 dark:text-green-400' : 'bg-gradient-to-r from-pink-600 to-purple-600 text-white hover:shadow-lg hover:shadow-pink-500/20'}`} data-id="element-5750">
            {isInCart ? <>
                <Check size={16} data-id="element-5751" />
                Added to Cart
              </> : <>
                <ShoppingCart size={16} data-id="element-5752" />
                Add to Cart
              </>}
          </button>
        </div>
      </div>;
  };
  // Render "Complete Your Set" upsell section
  const renderCompleteYourSet = () => {
    // For demo purposes, we'll show this after the first 4 items
    return <div className="col-span-full my-6 bg-gradient-to-r from-purple-50 to-pink-50 dark:from-purple-900/20 dark:to-pink-900/20 rounded-xl p-4 border border-purple-100 dark:border-purple-800/30" data-id="element-5753">
        <div className="flex flex-col md:flex-row items-center gap-4" data-id="element-5754">
          <div className="flex-shrink-0" data-id="element-5755">
            <div className="w-12 h-12 bg-gradient-to-r from-purple-500 to-pink-500 rounded-full flex items-center justify-center" data-id="element-5756">
              <Gift size={20} className="text-white" data-id="element-5757" />
            </div>
          </div>
          <div className="flex-grow" data-id="element-5758">
            <h3 className="text-lg font-bold mb-1" data-id="element-5759">Complete Your Collection</h3>
            <p className="text-sm text-gray-600 dark:text-gray-300" data-id="element-5760">
              Purchase the complete set and save 20%! Plus get 2X LuvToken
              rewards.
            </p>
          </div>
          <div className="flex-shrink-0" data-id="element-5761">
            <button className="px-4 py-2 bg-gradient-to-r from-pink-600 to-purple-600 rounded-lg text-white text-sm font-medium hover:shadow-lg hover:shadow-pink-500/20 transition-all duration-300 flex items-center gap-2" data-id="element-5762">
              <span data-id="element-5763">View Bundle</span>
              <ChevronRight size={16} data-id="element-5764" />
            </button>
          </div>
        </div>
      </div>;
  };
  // Get the title for the current marketplace category
  const getCategoryTitle = () => {
    if (marketplaceCategory === 'angel_skins') {
      return 'Angel Skins';
    } else if (marketplaceCategory === 'premium_videos') {
      return 'Premium Videos';
    } else if (marketplaceCategory === 'picture_sets') {
      return 'Picture Sets';
    } else if (activeCategory === 'all') {
      return 'All Products';
    } else if (activeCategory === 'supplements') {
      return 'Supplements';
    } else if (activeCategory === 'toys') {
      return 'Intimate Toys';
    } else {
      return 'Lingerie';
    }
  };
  // Quick view modal
  const renderQuickViewModal = () => {
    if (!showQuickView) return null;
    // Find the selected product
    const allProducts = [...angelSkins, ...premiumVideos, ...pictureSets, ...supplements, ...toys, ...lingerie];
    const product = allProducts.find(p => p.id === showQuickView);
    if (!product) return null;
    return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm animate-in fade-in duration-300" data-id="element-5765">
        <div className="relative w-full max-w-3xl bg-white dark:bg-gray-900 rounded-xl overflow-hidden shadow-2xl animate-in zoom-in-95 duration-300" data-id="element-5766">
          <button className="absolute top-4 right-4 z-10 w-8 h-8 flex items-center justify-center rounded-full bg-white/10 backdrop-blur-sm text-white hover:bg-white/20 transition-colors" onClick={() => setShowQuickView(null)} data-id="element-5767">
            <X size={18} data-id="element-5768" />
          </button>
          <div className="grid grid-cols-1 md:grid-cols-2" data-id="element-5769">
            {/* Product image */}
            <div className="relative aspect-square" data-id="element-5770">
              <img src={product.image} alt={product.name} className="w-full h-full object-cover" data-id="element-5771" />
              {/* Bestseller or New ribbon */}
              {product.isBestseller && <div className="absolute top-4 left-0 bg-gradient-to-r from-amber-500 to-yellow-500 text-white text-xs font-bold px-3 py-1 rounded-r-full shadow-md" data-id="element-5772">
                  <span className="flex items-center" data-id="element-5773">
                    <Star size={12} className="mr-1" fill="currentColor" data-id="element-5774" />
                    BESTSELLER
                  </span>
                </div>}
              {product.isNew && !product.isBestseller && <div className="absolute top-4 left-0 bg-gradient-to-r from-blue-500 to-cyan-500 text-white text-xs font-bold px-3 py-1 rounded-r-full shadow-md" data-id="element-5775">
                  <span className="flex items-center" data-id="element-5776">
                    <Sparkles size={12} className="mr-1" data-id="element-5777" />
                    NEW
                  </span>
                </div>}
            </div>
            {/* Product details */}
            <div className="p-6 flex flex-col" data-id="element-5778">
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-2" data-id="element-5779">
                {product.name}
              </h2>
              <p className="text-lg italic text-gray-600 dark:text-gray-300 font-serif mb-4" data-id="element-5780">
                {product.subtitle}
              </p>
              <div className="flex items-center gap-2 mb-4" data-id="element-5781">
                <div className="flex items-center gap-1 text-amber-500" data-id="element-5782">
                  <Star size={16} fill="currentColor" data-id="element-5783" />
                  <span className="font-medium" data-id="element-5784">{product.rating}</span>
                </div>
                <span className="text-gray-500 dark:text-gray-400" data-id="element-5785">
                  ({product.reviews} reviews)
                </span>
              </div>
              <p className="text-gray-700 dark:text-gray-300 mb-6" data-id="element-5786">
                {product.description}
              </p>
              <div className="flex items-center gap-3 mb-4" data-id="element-5787">
                <span className="text-2xl font-bold text-gray-900 dark:text-white" data-id="element-5788">
                  ${product.price.toFixed(2)}
                </span>
                <div className="flex items-center gap-1 bg-amber-100 dark:bg-amber-900/30 px-3 py-1.5 rounded-full" data-id="element-5789">
                  <Heart size={14} className="text-pink-500" fill="currentColor" data-id="element-5790" />
                  <span className="text-sm text-amber-800 dark:text-amber-300 font-medium" data-id="element-5791">
                    Earn {product.tokenReward} LuvTokens
                  </span>
                </div>
              </div>
              <div className="flex flex-wrap gap-2 mb-6" data-id="element-5792">
                {product.tags && product.tags.map((tag: string) => <span key={tag} className="px-2 py-1 bg-gray-100 dark:bg-gray-800 rounded-full text-xs text-gray-700 dark:text-gray-300" data-id="element-5793">
                      {tag}
                    </span>)}
              </div>
              <div className="mt-auto flex gap-3" data-id="element-5794">
                <button onClick={() => {
                handleAddToCart(product.id);
                setShowQuickView(null);
              }} className="flex-1 py-3 bg-gradient-to-r from-pink-600 to-purple-600 rounded-lg text-white font-medium hover:shadow-lg hover:shadow-pink-500/20 transition-all duration-300 flex items-center justify-center gap-2" data-id="element-5795">
                  <ShoppingCart size={18} data-id="element-5796" />
                  Add to Cart
                </button>
                <button onClick={() => {
                handleAddToCart(product.id);
                setShowQuickView(null);
              }} className="flex-1 py-3 bg-gradient-to-r from-purple-600 to-indigo-600 rounded-lg text-white font-medium hover:shadow-lg hover:shadow-purple-500/20 transition-all duration-300 flex items-center justify-center gap-2" data-id="element-5797">
                  <Zap size={18} data-id="element-5798" />
                  Buy Now
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>;
  };
  return <div className="w-full bg-white dark:bg-black min-h-screen" data-id="element-5799">
      {/* Hero Banner */}
      <div className="relative mb-8 overflow-hidden rounded-xl" data-id="element-5800">
        <div className="absolute inset-0 bg-gradient-to-r from-purple-900/70 to-pink-900/70 mix-blend-multiply" data-id="element-5801"></div>
        <div className="absolute inset-0 bg-[url('https://uploadthingy.s3.us-west-1.amazonaws.com/bWtgB6pZ1M5EyXrrqW9Z4T/image.png')] bg-cover bg-center blur-sm opacity-40" data-id="element-5802"></div>
        <div className="relative z-10 px-6 py-12 md:py-16 flex flex-col items-center" data-id="element-5803">
          {/* Animated sparkles */}
          <div className="absolute top-1/4 left-1/4 w-2 h-2 bg-white rounded-full animate-pulse" data-id="element-5804"></div>
          <div className="absolute top-3/4 left-2/3 w-1.5 h-1.5 bg-pink-300 rounded-full animate-pulse delay-75" data-id="element-5805"></div>
          <div className="absolute top-1/3 right-1/4 w-2 h-2 bg-purple-300 rounded-full animate-pulse delay-150" data-id="element-5806"></div>
          <div className="absolute bottom-1/4 right-1/3 w-1.5 h-1.5 bg-white rounded-full animate-pulse delay-300" data-id="element-5807"></div>
          <h1 className="text-2xl md:text-3xl lg:text-4xl font-bold text-white text-center mb-3 drop-shadow-lg" data-id="element-5808">
            Discover Exclusive Creations & Skins
            <br data-id="element-5809" />
            From Your Favorite Angels
          </h1>
          <p className="text-sm md:text-base italic text-pink-100/90 text-center max-w-2xl mb-8 font-serif" data-id="element-5810">
            Indulge in premium products designed to elevate your intimate
            experiences and connections
          </p>
          {/* Progress tracker */}
          <div className="w-full max-w-md bg-black/30 backdrop-blur-md rounded-lg p-3 mb-8 border border-pink-500/20" data-id="element-5811">
            <div className="flex items-center justify-between mb-2" data-id="element-5812">
              <span className="text-white text-sm" data-id="element-5813">
                Unlock 2 more items to get +500 LuvTokens
              </span>
              <span className="text-xs bg-gradient-to-r from-amber-400 to-yellow-300 text-black font-bold px-2 py-0.5 rounded-full" data-id="element-5814">
                BONUS
              </span>
            </div>
            <div className="h-2 bg-gray-700 rounded-full overflow-hidden" data-id="element-5815">
              <div className="h-full w-3/5 bg-gradient-to-r from-pink-500 to-purple-500 rounded-full" data-id="element-5816"></div>
            </div>
          </div>
          {/* Featured category pills */}
          <div className="flex flex-wrap justify-center gap-3 max-w-3xl" data-id="element-5817">
            <button onClick={() => {
            const event = new CustomEvent('changeMarketplaceCategory', {
              detail: {
                category: 'angel_skins'
              }
            });
            document.dispatchEvent(event);
          }} className="px-5 py-3 bg-gradient-to-r from-purple-600 to-pink-600 rounded-full text-white font-medium shadow-lg shadow-purple-900/30 hover:shadow-purple-500/40 hover:scale-105 transition-all duration-300 flex items-center gap-2" data-id="element-5818">
              <Sparkles size={18} className="text-pink-200" data-id="element-5819" />
              <span data-id="element-5820">Angel Skins</span>
            </button>
            <button onClick={() => {
            const event = new CustomEvent('changeMarketplaceCategory', {
              detail: {
                category: 'premium_videos'
              }
            });
            document.dispatchEvent(event);
          }} className="px-5 py-3 bg-gradient-to-r from-pink-600 to-red-600 rounded-full text-white font-medium shadow-lg shadow-pink-900/30 hover:shadow-pink-500/40 hover:scale-105 transition-all duration-300 flex items-center gap-2" data-id="element-5821">
              <Play size={18} className="text-pink-200" data-id="element-5822" />
              <span data-id="element-5823">Premium Videos</span>
            </button>
            <button onClick={() => {
            const event = new CustomEvent('changeMarketplaceCategory', {
              detail: {
                category: 'picture_sets'
              }
            });
            document.dispatchEvent(event);
          }} className="px-5 py-3 bg-gradient-to-r from-blue-600 to-indigo-600 rounded-full text-white font-medium shadow-lg shadow-blue-900/30 hover:shadow-blue-500/40 hover:scale-105 transition-all duration-300 flex items-center gap-2" data-id="element-5824">
              <Camera size={18} className="text-blue-200" data-id="element-5825" />
              <span data-id="element-5826">Picture Sets</span>
            </button>
            <button onClick={() => setActiveCategory('supplements')} className="px-5 py-3 bg-gradient-to-r from-green-600 to-teal-600 rounded-full text-white font-medium shadow-lg shadow-green-900/30 hover:shadow-green-500/40 hover:scale-105 transition-all duration-300 flex items-center gap-2" data-id="element-5827">
              <Pill size={18} className="text-green-200" data-id="element-5828" />
              <span data-id="element-5829">Supplements</span>
            </button>
            <button onClick={() => setActiveCategory('toys')} className="px-5 py-3 bg-gradient-to-r from-rose-600 to-pink-600 rounded-full text-white font-medium shadow-lg shadow-rose-900/30 hover:shadow-rose-500/40 hover:scale-105 transition-all duration-300 flex items-center gap-2" data-id="element-5830">
              <Heart size={18} className="text-rose-200" data-id="element-5831" />
              <span data-id="element-5832">Intimate Toys</span>
            </button>
            <button onClick={() => setActiveCategory('lingerie')} className="px-5 py-3 bg-gradient-to-r from-fuchsia-600 to-purple-600 rounded-full text-white font-medium shadow-lg shadow-fuchsia-900/30 hover:shadow-fuchsia-500/40 hover:scale-105 transition-all duration-300 flex items-center gap-2" data-id="element-5833">
              <Heart size={18} className="text-fuchsia-200" data-id="element-5834" />
              <span data-id="element-5835">Lingerie</span>
            </button>
            <button className="px-5 py-3 bg-gradient-to-r from-amber-600 to-yellow-500 rounded-full text-white font-medium shadow-lg shadow-amber-900/30 hover:shadow-amber-500/40 hover:scale-105 transition-all duration-300 flex items-center gap-2" data-id="element-5836">
              <Package size={18} className="text-amber-200" data-id="element-5837" />
              <span data-id="element-5838">Gift Sets</span>
            </button>
          </div>
        </div>
      </div>
      <div className="max-w-[860px] mx-auto px-4 py-6 md:max-w-[860px] lg:max-w-[1080px]" data-id="element-5839">
        {/* Header */}
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-6" data-id="element-5840">
          <div data-id="element-5841">
            <h1 className="text-2xl font-bold text-gray-900 dark:text-white" data-id="element-5842">
              Creator Marketplace
            </h1>
            <p className="text-gray-600 dark:text-gray-400" data-id="element-5843">
              Discover premium products curated by your favorite creators
            </p>
          </div>
          <div className="flex items-center gap-2 mt-4 md:mt-0" data-id="element-5844">
            <button className="flex items-center gap-1 px-3 py-1.5 bg-gray-100 dark:bg-gray-800 rounded-full text-sm hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors" data-id="element-5845">
              <ShoppingCart size={16} className="text-gray-500 dark:text-gray-400" data-id="element-5846" />
              <span data-id="element-5847">Cart ({cartItems.length})</span>
            </button>
            <button className="flex items-center gap-1 px-3 py-1.5 bg-gray-100 dark:bg-gray-800 rounded-full text-sm hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors" data-id="element-5848">
              <Heart size={16} className="text-gray-500 dark:text-gray-400" data-id="element-5849" />
              <span data-id="element-5850">Wishlist</span>
            </button>
          </div>
        </div>
        {/* Marketplace Category Header */}
        {renderMarketplaceCategoryHeader()}
        {/* Search and filters */}
        <div className="mb-6" data-id="element-5851">
          <div className="flex flex-col md:flex-row gap-4 mb-4" data-id="element-5852">
            <div className="relative flex-grow" data-id="element-5853">
              <input type="text" placeholder="Search products..." className="w-full bg-gray-100 dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg px-10 py-2 focus:outline-none focus:ring-2 focus:ring-pink-500 dark:text-white" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} data-id="element-5854" />
              <Search size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500 dark:text-gray-400" data-id="element-5855" />
            </div>
            <div className="flex gap-2" data-id="element-5856">
              <button className="flex items-center gap-1 px-3 py-2 bg-gray-100 dark:bg-gray-800 rounded-lg text-sm hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors" onClick={() => setShowFilters(!showFilters)} data-id="element-5857">
                <Filter size={16} className="text-gray-500 dark:text-gray-400" data-id="element-5858" />
                <span data-id="element-5859">Filters</span>
                <ChevronDown size={16} className={`text-gray-500 dark:text-gray-400 transition-transform ${showFilters ? 'rotate-180' : ''}`} data-id="element-5860" />
              </button>
              <div className="relative" data-id="element-5861">
                <select className="appearance-none bg-gray-100 dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg px-3 py-2 pr-8 text-sm focus:outline-none focus:ring-2 focus:ring-pink-500 dark:text-white" value={sortBy} onChange={e => setSortBy(e.target.value)} data-id="element-5862">
                  <option value="popular" data-id="element-5863">Most Popular</option>
                  <option value="rating" data-id="element-5864">Highest Rated</option>
                  <option value="newest" data-id="element-5865">Newest</option>
                  <option value="price-low" data-id="element-5866">Price: Low to High</option>
                  <option value="price-high" data-id="element-5867">Price: High to Low</option>
                </select>
                <ChevronDown size={16} className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 dark:text-gray-400 pointer-events-none" data-id="element-5868" />
              </div>
            </div>
          </div>
          {/* Expanded filters */}
          {showFilters && <div className="bg-gray-50 dark:bg-gray-800 rounded-lg p-4 mb-4 border border-gray-200 dark:border-gray-700 animate-in fade-in duration-300" data-id="element-5869">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-5870">
                <div data-id="element-5871">
                  <h3 className="text-sm font-medium mb-2 dark:text-white" data-id="element-5872">
                    Price Range
                  </h3>
                  <div className="flex items-center gap-2" data-id="element-5873">
                    <input type="range" min="0" max="200" value={priceRange[0]} onChange={e => setPriceRange([parseInt(e.target.value), priceRange[1]])} className="w-full h-2 bg-gray-200 dark:bg-gray-700 rounded-lg appearance-none cursor-pointer" data-id="element-5874" />
                    <span className="text-xs dark:text-gray-300" data-id="element-5875">
                      ${priceRange[0]}
                    </span>
                  </div>
                  <div className="flex items-center gap-2 mt-2" data-id="element-5876">
                    <input type="range" min="0" max="200" value={priceRange[1]} onChange={e => setPriceRange([priceRange[0], parseInt(e.target.value)])} className="w-full h-2 bg-gray-200 dark:bg-gray-700 rounded-lg appearance-none cursor-pointer" data-id="element-5877" />
                    <span className="text-xs dark:text-gray-300" data-id="element-5878">
                      ${priceRange[1]}
                    </span>
                  </div>
                </div>
                <div data-id="element-5879">
                  <h3 className="text-sm font-medium mb-2 dark:text-white" data-id="element-5880">
                    Product Tags
                  </h3>
                  <div className="flex flex-wrap gap-2" data-id="element-5881">
                    {['bestseller', 'popular', 'premium', 'natural', 'vegan', 'app-controlled'].map(tag => <button key={tag} className="px-2 py-1 bg-gray-200 dark:bg-gray-700 rounded-full text-xs dark:text-gray-300 hover:bg-gray-300 dark:hover:bg-gray-600 transition-colors" data-id="element-5882">
                        {tag}
                      </button>)}
                  </div>
                </div>
                <div data-id="element-5883">
                  <h3 className="text-sm font-medium mb-2 dark:text-white" data-id="element-5884">
                    Availability
                  </h3>
                  <div className="flex items-center gap-2" data-id="element-5885">
                    <input type="checkbox" id="in-stock" className="rounded text-pink-500 focus:ring-pink-500" defaultChecked data-id="element-5886" />
                    <label htmlFor="in-stock" className="text-sm dark:text-gray-300" data-id="element-5887">
                      In Stock Only
                    </label>
                  </div>
                </div>
              </div>
            </div>}
          {/* Category tabs - Only show if not in a special marketplace category */}
          {marketplaceCategory === 'all' && <div className="flex overflow-x-auto gap-2 pb-2 scrollbar-hide" data-id="element-5888">
              <button className={`flex items-center gap-1 px-3 py-1.5 rounded-full text-sm whitespace-nowrap transition-colors ${activeCategory === 'all' ? 'bg-gradient-to-r from-pink-600 to-purple-600 text-white shadow-md shadow-pink-500/20' : 'bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700'}`} onClick={() => setActiveCategory('all')} data-id="element-5889">
                <ShoppingBag size={14} data-id="element-5890" />
                <span data-id="element-5891">All Products</span>
              </button>
              <button className={`flex items-center gap-1 px-3 py-1.5 rounded-full text-sm whitespace-nowrap transition-colors ${activeCategory === 'angel_skins' ? 'bg-gradient-to-r from-pink-600 to-purple-600 text-white shadow-md shadow-pink-500/20' : 'bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700'}`} onClick={() => setActiveCategory('angel_skins')} data-id="element-5892">
                <Sparkles size={14} data-id="element-5893" />
                <span data-id="element-5894">Angel Skins</span>
              </button>
              <button className={`flex items-center gap-1 px-3 py-1.5 rounded-full text-sm whitespace-nowrap transition-colors ${activeCategory === 'premium_videos' ? 'bg-gradient-to-r from-pink-600 to-purple-600 text-white shadow-md shadow-pink-500/20' : 'bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700'}`} onClick={() => setActiveCategory('premium_videos')} data-id="element-5895">
                <Play size={14} data-id="element-5896" />
                <span data-id="element-5897">Premium Videos</span>
              </button>
              <button className={`flex items-center gap-1 px-3 py-1.5 rounded-full text-sm whitespace-nowrap transition-colors ${activeCategory === 'picture_sets' ? 'bg-gradient-to-r from-pink-600 to-purple-600 text-white shadow-md shadow-pink-500/20' : 'bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700'}`} onClick={() => setActiveCategory('picture_sets')} data-id="element-5898">
                <Camera size={14} data-id="element-5899" />
                <span data-id="element-5900">Picture Sets</span>
              </button>
              <button className={`flex items-center gap-1 px-3 py-1.5 rounded-full text-sm whitespace-nowrap transition-colors ${activeCategory === 'supplements' ? 'bg-gradient-to-r from-pink-600 to-purple-600 text-white shadow-md shadow-pink-500/20' : 'bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700'}`} onClick={() => setActiveCategory('supplements')} data-id="element-5901">
                <Pill size={14} data-id="element-5902" />
                <span data-id="element-5903">Supplements</span>
              </button>
              <button className={`flex items-center gap-1 px-3 py-1.5 rounded-full text-sm whitespace-nowrap transition-colors ${activeCategory === 'toys' ? 'bg-gradient-to-r from-pink-600 to-purple-600 text-white shadow-md shadow-pink-500/20' : 'bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700'}`} onClick={() => setActiveCategory('toys')} data-id="element-5904">
                <Heart size={14} data-id="element-5905" />
                <span data-id="element-5906">Intimate Toys</span>
              </button>
              <button className={`flex items-center gap-1 px-3 py-1.5 rounded-full text-sm whitespace-nowrap transition-colors ${activeCategory === 'lingerie' ? 'bg-gradient-to-r from-pink-600 to-purple-600 text-white shadow-md shadow-pink-500/20' : 'bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700'}`} onClick={() => setActiveCategory('lingerie')} data-id="element-5907">
                <Heart size={14} data-id="element-5908" />
                <span data-id="element-5909">Lingerie</span>
              </button>
              <button className="flex items-center gap-1 px-3 py-1.5 rounded-full text-sm whitespace-nowrap bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors" data-id="element-5910">
                <Gift size={14} data-id="element-5911" />
                <span data-id="element-5912">Gift Sets</span>
              </button>
            </div>}
        </div>
        {/* Personalized recommendations - only show on main marketplace view */}
        {marketplaceCategory === 'all' && activeCategory === 'all' && <div className="mb-8" data-id="element-5913">
            <div className="flex items-center justify-between mb-4" data-id="element-5914">
              <h2 className="text-lg font-bold text-gray-900 dark:text-white" data-id="element-5915">
                Recommended For You
              </h2>
              <button className="text-sm text-pink-500 dark:text-pink-400 flex items-center gap-1" data-id="element-5916">
                View All <ChevronRight size={16} data-id="element-5917" />
              </button>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-5918">
              {personalizedSupplements.map(renderProductCard)}
              {personalizedToys.map(renderProductCard)}
            </div>
            <div className="mt-2 text-xs text-gray-500 dark:text-gray-400" data-id="element-5919">
              <p data-id="element-5920">
                Recommended based on:{' '}
                {supplementReasons[personalizedSupplements[0]?.id]}
              </p>
            </div>
          </div>}
        {/* Product grid */}
        <div data-id="element-5921">
          <h2 className="text-lg font-bold text-gray-900 dark:text-white mb-4" data-id="element-5922">
            {getCategoryTitle()}
            <span className="text-sm font-normal text-gray-500 dark:text-gray-400 ml-2" data-id="element-5923">
              ({filteredItems.length} items)
            </span>
          </h2>
          {filteredItems.length > 0 ? <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-5924">
              {filteredItems.slice(0, 4).map(renderProductCard)}
              {/* Complete Your Set upsell after 4 items */}
              {filteredItems.length > 4 && renderCompleteYourSet()}
              {/* Remaining items */}
              {filteredItems.slice(4).map(renderProductCard)}
            </div> : <div className="bg-gray-50 dark:bg-gray-800 rounded-lg p-8 text-center" data-id="element-5925">
              <div className="w-16 h-16 mx-auto flex items-center justify-center bg-gray-200 dark:bg-gray-700 rounded-full mb-4" data-id="element-5926">
                <Search size={24} className="text-gray-500 dark:text-gray-400" data-id="element-5927" />
              </div>
              <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-2" data-id="element-5928">
                No products found
              </h3>
              <p className="text-gray-500 dark:text-gray-400 max-w-md mx-auto" data-id="element-5929">
                We couldn't find any products matching your criteria. Try
                adjusting your filters or search terms.
              </p>
              <button className="mt-4 px-4 py-2 bg-pink-500 text-white rounded-lg hover:bg-pink-600 transition-colors" onClick={() => {
            setSearchQuery('');
            setActiveCategory('all');
            setPriceRange([0, 100]);
          }} data-id="element-5930">
                Clear Filters
              </button>
            </div>}
        </div>
      </div>
      {/* Quick View Modal */}
      {renderQuickViewModal()}
      <style jsx data-id="element-5931">{`
        .scrollbar-hide::-webkit-scrollbar {
          display: none;
        }
        .scrollbar-hide {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
        .image-high-quality {
          image-rendering: auto;
        }
        @keyframes pulse {
          0%,
          100% {
            opacity: 1;
            transform: scale(1);
          }
          50% {
            opacity: 0.7;
            transform: scale(1.1);
          }
        }
        .animate-pulse {
          animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
        }
        .delay-75 {
          animation-delay: 0.75s;
        }
        .delay-150 {
          animation-delay: 1.5s;
        }
        .delay-300 {
          animation-delay: 3s;
        }
      `}</style>
    </div>;
};